const PREFIX = '[stavyn:route]';

function safeString(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  try {
    return String(value);
  } catch {
    return '[unprintable]';
  }
}

export function logRouteTransition(from, to) {
  if (process.env.NODE_ENV === 'production') return;
  console.info(`${PREFIX} navigate`, { from, to, at: new Date().toISOString() });
}

export function logRouteMount(routeName, pathname) {
  if (process.env.NODE_ENV === 'production') return;
  console.info(`${PREFIX} mount`, { route: routeName, pathname, at: new Date().toISOString() });
}

export function logRouteError(context, error, errorInfo, extra = {}) {
  const payload = {
    context: safeString(context),
    message: safeString(error?.message || error),
    stack: error?.stack,
    componentStack: errorInfo?.componentStack,
    ...extra,
    at: new Date().toISOString(),
  };
  console.error(`${PREFIX} error`, payload);
}

export function installGlobalRouteDiagnostics() {
  if (typeof window === 'undefined') return;

  window.addEventListener('error', (event) => {
    logRouteError('window.error', event.error || event.message, null, {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    logRouteError(
      'window.unhandledrejection',
      reason instanceof Error ? reason : new Error(safeString(reason)),
      null
    );
  });
}
